// extracted by mini-css-extract-plugin
var _1 = "wGpAfDENSEkq0bBxpeK_";
export { _1 as "progress-panel" }
